import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_IE',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  '27abeb10-8fe3-46de-839e-3019204b28c9',
  ''
);
